import React from 'react';
import cd from 'debug';
// import { useIntl } from 'react-intl';

import { AsyncOddButton } from 'modules/betslip/async';
import { MarketValue } from '../MarketsValue';
// import { MarketSelect } from '../MarketSelect';
// import { MarketHcpOption } from '../MarketHcpOption';
// import useMarketRow from '../Markets/useMarketRow';
// import { RenderFunction } from '../MarketSelect/types';
// import { MarketRowToggler } from 'components';
// import { getHcpSpecifier } from '../MarketsValue/utils';
// import useCompetitorName from '../Markets/useCompetitorName';
// import { TITLES_BY_SPECIFIER } from 'app-constants';
import './MarketHcpRow.scss';

const debug = cd('match-list:components:MarketHcpRow');

interface OwnProps {
    oddId: string | undefined;
    value: string;
    // topMarketId: string;
    // marketType: number;
    // getCustomMarketMatches: () => void;
    // matchId: string;
    // selectedMarketId: string;
    // isAway: boolean;
}

type Props = OwnProps;

const MarketHcpRow: React.FC<Props> = props => {
    debug('render', props);

    const {
        value,
        oddId,
        // getCustomMarketMatches,
        // topMarketId,
        // matchId,
        // selectedMarketId,
        // isAway,
        // marketType,
    } = props;

    // const {
    //     isOpen,
    //     setIsOpen,
    //     marketIds,
    //     showToggler,
    //     onTogglerClick,
    // } = useMarketRow({
    //     matchId,
    //     marketType,
    //     topMarketId,
    //     getSpecifier: getHcpSpecifier,
    //     selectedMarketId,
    //     getCustomMarketMatches,
    // });

    // const competitorName = useCompetitorName({ oddId });

    // const renderOptions: RenderFunction = useCallback(
    //     ({ height, onClick }) =>
    //         marketIds.map(marketId => (
    //             <MarketHcpOption
    //                 key={marketId}
    //                 marketId={marketId}
    //                 topMarketId={topMarketId}
    //                 onClick={onClick}
    //                 getSpecifier={getHcpSpecifier}
    //                 height={height}
    //                 isAway={isAway}
    //             />
    //         )),
    //     [marketIds, topMarketId, isAway]
    // );

    return (
        <div styleName="container" className="__app-MarketHcpRow-container">
            <MarketValue value={value} />
            {/* {false && showToggler && (
                <MarketRowToggler onClick={onTogglerClick} rotate={true} />
            )} */}
            {/* {false && isOpen && (
                <MarketSelect
                    allMarketsIds={marketIds}
                    selectedMarketId={selectedMarketId}
                    title={<MarketHcpTitle team={competitorName} />}
                    render={renderOptions}
                    onTogglerClick={setIsOpen}
                />
            )} */}
            <div styleName="col button">
                <AsyncOddButton oddId={oddId} showResult={true} />
            </div>
        </div>
    );
};

// interface TitleProps {
//     team: string;
// }

// const MarketHcpTitle: React.FC<TitleProps> = ({ team }) => {
//     const { formatMessage } = useIntl();
//     const title = formatMessage(TITLES_BY_SPECIFIER.handicap);

//     return (
//         <React.Fragment>
//             <div styleName="title-col" title={title}>
//                 {title}
//             </div>
//             <div styleName="title-col " title={team}>
//                 {team}
//             </div>
//         </React.Fragment>
//     );
// };

export default MarketHcpRow;
